import React, { Component, Fragment } from 'react'
import { Query } from 'react-apollo'

import { SELF_QUERY, ORDER_QUERY, PORTAL_ORDER_QUERY } from '../../queries'
import { AUTH_TOKEN, SELECTED_BRANCH, HOOK_URL, OCI } from '../../constants'

import Header from '../Header/Header/'
import StickyHeader from '../Header/StickyHeader/'
import MobileHeader from '../MobileHeader/MobileHeader/'
import BranchPopup from '../BranchPopup'
import ContactPopup from '../ContactPopup/'
import Loader from '../Loader'
import Error from '../Error'

class Headers extends Component {
  constructor(props) {
    super(props)

    this.state = {
      branchPopupActive: false,
      contactPopupActive: false
    }
  }

  calculateOrders(order) {
    let amount = 0
    Object.keys(order).map((key, index) => {
      return (amount = amount + order[key])
    })

    if (amount > 999) {
      return '999+'
    } else {
      return amount
    }
  }

  handleLogout() {
    if (window.localStorage.getItem(AUTH_TOKEN)) {
      window.localStorage.removeItem(AUTH_TOKEN)
    } else {
      window.sessionStorage.removeItem(AUTH_TOKEN)
    }
    if (window.localStorage.getItem(SELECTED_BRANCH)) {
      window.localStorage.removeItem(SELECTED_BRANCH)
    } else {
      window.sessionStorage.removeItem(SELECTED_BRANCH)
    }
    if (window.sessionStorage.getItem(HOOK_URL)) {
      window.sessionStorage.removeItem(HOOK_URL)
    }
    if (window.sessionStorage.getItem(OCI)) {
      window.sessionStorage.removeItem(OCI)
    }
  }

  openBranchPopup() {
    this.setState({ branchPopupActive: true })
    document.body.classList.add('popup-active')
    document.documentElement.classList.add('popup-active')
  }

  closeBranchPopup() {
    this.setState({ branchPopupActive: false })
    document.body.classList.remove('popup-active')
    document.documentElement.classList.remove('popup-active')
  }

  closeBranchPopupContainer(e) {
    if (e.target.classList.contains('js-popup-container')) {
      this.setState({ branchPopupActive: false })
      document.body.classList.remove('popup-active')
      document.documentElement.classList.remove('popup-active')
    }
  }

  openContactPopup() {
    this.setState({ contactPopupActive: true })
    document.body.classList.toggle('popup-active')
    document.documentElement.classList.toggle('popup-active')
  }

  closeContactPopup() {
    this.setState({ contactPopupActive: false })
    document.body.classList.remove('popup-active')
    document.documentElement.classList.remove('popup-active')
  }

  closeContactPopupContainer(e) {
    if (e.target.classList.contains('js-popup-container')) {
      this.setState({ contactPopupActive: false })
      document.body.classList.remove('popup-active')
      document.documentElement.classList.remove('popup-active')
    }
  }

  render() {
    return (
      <Query query={SELF_QUERY}>
        {({ loading, error, data }) => {
          if (loading) return <Loader from="0%" to="75%" fixed />
          if (error) return <Error error="de gebruikersgegevens" />
          const { self } = data
          const permissions = {
            multipleBranches: self.branches.length > 1,
            viewOrders: (self.permissions.includes('VIEW_ORDERS') || self.role === 'MANAGER') && !this.props.suspended,
            viewMachines: (self.permissions.includes('VIEW_MACHINES') || self.role === 'MANAGER') && !this.props.suspended,
            viewAssortiment: (self.permissions.includes('VIEW_ASSORTIMENT') || self.role === 'MANAGER') && !this.props.suspended,
            viewBranch: (self.permissions.includes('VIEW_BRANCH') || self.role === 'MANAGER'),
            viewAgenda: (self.permissions.includes('VIEW_AGENDA') || self.role === 'MANAGER') && !this.props.suspended,
            reportError: (self.permissions.includes('REPORT_ERROR') || self.role === 'MANAGER') && !this.props.suspended,
            viewUsers: (self.permissions.includes('VIEW_USERS') || self.role === 'MANAGER') && !this.props.suspended,
            editProfile: (self.permissions.includes('EDIT_PROFILE') || self.role === 'MANAGER') && !this.props.suspended,
            viewInvoices: (self.permissions.includes('VIEW_INVOICES') || self.role === 'MANAGER'),
            viewTech: (self.permissions.includes('VIEW_TECH') || self.role === 'MANAGER'),
            viewOldOrders: (self.permissions.includes('VIEW_OLD_ORDER') || self.role === 'MANAGER') && !this.props.suspended
          }

          return (
            <Query query={this.props.portalOrderId ? PORTAL_ORDER_QUERY : ORDER_QUERY} variables={{ id: this.props.portalOrderId ? this.props.portalOrderId : this.props.orderId }}>
              {({ loading, data }) => {
                if (loading) return <Loader from="75%" to="100%" fixed />
                let type = this.props.portalOrderId ? 'portalOrder' : 'order'
                let order = {}

                if (data && data[type]) {
                  data[type].orderParts.map(orderPart => {
                    return (order[orderPart.product.id] = orderPart.amount)
                  })
                }
                
                let orderAmount = 0
                if (this.props.portalOrderId) {
                  orderAmount = this.calculateOrders(order)
                }

                return (
                  <Fragment>
                    <Header
                      branchName={this.props.branchName}
                      color={this.props.color}
                      onSwitchBranch={this.openBranchPopup.bind(this)}
                      handleLogout={this.handleLogout.bind(this)}
                      permissions={permissions}
                      nrOfOrders={orderAmount}
                      gender={self.gender}
                      onClickContact={this.openContactPopup.bind(this)}
                    />
                    <StickyHeader
                      branchName={this.props.branchName}
                      onSwitchBranch={this.openBranchPopup.bind(this)}
                      handleLogout={this.handleLogout.bind(this)}
                      permissions={permissions}
                      nrOfOrders={orderAmount}
                      gender={self.gender}
                      onClickContact={this.openContactPopup.bind(this)}
                    />
                    <MobileHeader
                      branchName={this.props.branchName}
                      logo={this.props.logo}
                      onSwitchBranch={this.openBranchPopup.bind(this)}
                      handleLogout={this.handleLogout.bind(this)}
                      permissions={permissions}
                      nrOfOrders={orderAmount}
                      gender={self.gender}
                      onClickContact={this.openContactPopup.bind(this)}
                    />

                    {this.state.branchPopupActive ? (
                      <BranchPopup
                        popupActive={this.state.branchPopupActive}
                        closePopup={this.closeBranchPopup.bind(this)}
                        closePopupContainer={this.closeBranchPopupContainer.bind(this)}
                      />
                    ) : null}
                    {this.state.contactPopupActive ? (
                      <ContactPopup
                        popupActive={this.state.contactPopupActive}
                        closePopup={this.closeContactPopup.bind(this)}
                        closePopupContainer={this.closeContactPopupContainer.bind(this)}
                      />
                    ) : null}
                  </Fragment>
                )
              }}
            </Query>
          )
        }}
      </Query>
    )
  }
}

export default Headers



// WEBPACK FOOTER //
// ./src/components/Headers/index.js